import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/ui/css/styles.css';

// Backstage (signals/guest auth) calls crypto.randomUUID(), which some
// browsers only expose in a "secure context". Polyfill via getRandomValues.
(() => {
  const cryptoObj = globalThis.crypto as
    | (Crypto & { randomUUID?: () => `${string}-${string}-${string}-${string}-${string}` })
    | undefined;
  if (!cryptoObj || typeof cryptoObj.randomUUID === 'function') {
    return;
  }
  if (typeof cryptoObj.getRandomValues !== 'function') {
    return;
  }
  cryptoObj.randomUUID = function randomUUID() {
    const bytes = new Uint8Array(16);
    cryptoObj.getRandomValues(bytes);
    bytes[6] = (bytes[6]! & 0x0f) | 0x40;
    bytes[8] = (bytes[8]! & 0x3f) | 0x80;
    const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}` as `${string}-${string}-${string}-${string}-${string}`;
  };
})();

ReactDOM.createRoot(document.getElementById('root')!).render(App.createRoot());
